import React, { useEffect, useState } from 'react'
import BannerCarousel from '../../components/common/BannerCarousel/BannerCarousel'
import StatsCard from '../../components/common/StartCards'
import { statsData } from './Home'
import TrainingCalendar from './TrainingPage/TraningPage'
import Offerings from './OfferingCards/OfferingCardsMain'
import TestimonialsSection from './TestimonialsSection/TestimonialsSection'
import GallerySection from './GallerySection/GallerySection'
import YouTubeVideos from './Videos/Videos'
import { useBannerList } from './api'
import InitialPopup from '../../components/common/AdvertisementPopup.tsx'
import OurPartners from './OurPartners/OurPartners'

const Home = () => {
  const { data, isLoading, isError } = useBannerList()
  const [showPopup, setShowPopup] = useState(false)

  useEffect(() => {
    const hasShown = sessionStorage.getItem('initialPopupShown')
    if (!hasShown) {
      setShowPopup(true)
      sessionStorage.setItem('initialPopupShown', 'true')
    }
  }, [])

  const bannerImages = data
    ? data
        .filter((item: any) => item.status === 'active')
        .map((item: any) => item.file)
    : []

  return (
    <div>
      {showPopup && <InitialPopup autoClose={false} closeAfter={10000} />}
      {isLoading ? (
        <div>Loading banners...</div>
      ) : isError ? (
        <div>Error loading banners.</div>
      ) : (
        <BannerCarousel images={bannerImages} />
      )}
      <StatsCard stats={statsData} />
      <TrainingCalendar />
      <Offerings />
      <TestimonialsSection />
      <GallerySection />
      <YouTubeVideos />
      <OurPartners />
    </div>
  )
}

export default Home
